import { Component, Input, OnDestroy } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';
import { Club, Country } from '~core/models';

/**
 * Displays the first step of customer merge process.
 */
@UntilDestroy()
@Component({
  selector: 'app-compare-data',
  templateUrl: 'compare-data.component.html',
})
export class CompareDataComponent implements OnDestroy {
  @Input() public selectedClub: Club;
  @Input() public countries: Array<Country> = [];
  @Input() public firstCustomerData: any = [];
  @Input() public secondCustomerData: any = [];

  constructor(public tablesTranslations: TablesTranslations) { }

  public ngOnDestroy(): void { }

}
